var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { debounce } from 'lodash';
import * as React from 'react';
import { isClientSide } from './ssr';
var HeightContext = React.createContext(0);
var WidthContext = React.createContext(0);
var SubscriptionContext = React.createContext(null);
export var Provider = function (props) {
    var _a = React.useState(0), subscribers = _a[0], setSubscribers = _a[1];
    var _b = React.useState(isClientSide ? [window.innerWidth, window.innerHeight] : [0, 0]), dimension = _b[0], setDimension = _b[1];
    var dimensionRef = React.useRef(dimension);
    dimensionRef.current = dimension;
    var handler = React.useMemo(function () {
        return debounce(function () {
            if (window.innerWidth !== dimensionRef.current[0] ||
                window.innerHeight !== dimensionRef.current[1]) {
                setDimension([window.innerWidth, window.innerHeight]);
            }
        }, 200);
    }, []);
    var hasListeners = Boolean(subscribers);
    React.useEffect(function () {
        if (!isClientSide) {
            return;
        }
        if (hasListeners) {
            window.addEventListener('resize', handler);
            return function () { return window.removeEventListener('resize', handler); };
        }
        window.removeEventListener('resize', handler);
    }, [handler, hasListeners]);
    var subscription = React.useCallback(function () { return function () {
        setSubscribers(function (i) { return i + 1; });
        return function () { return setSubscribers(function (i) { return i - 1; }); };
    }; }, []);
    return (React.createElement(SubscriptionContext.Provider, { value: subscription },
        React.createElement(WidthContext.Provider, { value: dimension[0] },
            React.createElement(HeightContext.Provider, __assign({}, props, { value: dimension[1] })))));
};
var useListener = function () {
    var subscription = React.useContext(SubscriptionContext);
    if (!subscription) {
        throw new Error('`useWindow` hooks called outside their context.');
    }
    React.useEffect(subscription, []);
};
export var useWindowSize = function () {
    useListener();
    var height = React.useContext(HeightContext);
    var width = React.useContext(WidthContext);
    return React.useMemo(function () { return ({ height: height, width: width }); }, [height, width]);
};
export var useWindowHeight = function () {
    useListener();
    return React.useContext(HeightContext);
};
export var useWindowWidth = function () {
    useListener();
    return React.useContext(WidthContext);
};
//# sourceMappingURL=useWindowSize.js.map